import { inject, Injectable } from '@angular/core';

import { DeviceStatus, DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceBehaviorPluginsService } from '@shure/shared/angular/device-behavior/core';
import { CoverageDevice } from '@shure/shared/angular/features/device-coverage/data-access';

import { OnboardingAction, OnboardingStage, OnboardingStep } from '../models';

import { DeviceCoverage3dOnboardingDeviceBehavior } from './coverage-3-d-onboarding.device-behavior';

export interface OnboardingStepConfig {
	name: OnboardingStep;
	actions: OnboardingAction[];
	device: CoverageDevice;
}

const baseCoverageDevice: CoverageDevice = {
	id: '',
	model: DeviceModel.UNKNOWN,
	status: DeviceStatus.Online,
	virtual: false,
	features: {}
};

@Injectable({ providedIn: 'root' })
export class Coverage3dOnboardingDeviceBehaviorService {
	public readonly plugins = inject(DeviceBehaviorPluginsService);

	public getOnboardingStepsConfigs(model: DeviceModel): OnboardingStepConfig[] {
		return [
			{
				name: OnboardingStep.SceneClickAndDrag,
				actions: [OnboardingAction.SceneDrag, OnboardingAction.SceneScroll],
				device: { ...baseCoverageDevice, model }
			},
			{ name: OnboardingStep.LobeAdd, actions: [], device: { ...baseCoverageDevice, model } },
			{ name: OnboardingStep.LobeClickAndDrag, actions: [], device: { ...baseCoverageDevice, model } },
			{ name: OnboardingStep.LobeMultiSelect, actions: [], device: { ...baseCoverageDevice, model } },
			{ name: OnboardingStep.LobeSnap, actions: [], device: { ...baseCoverageDevice, model } }
		];
	}

	public getStageTitle(model: DeviceModel, stage: OnboardingStage): string | undefined {
		return (
			this.plugins.get<DeviceCoverage3dOnboardingDeviceBehavior>(model)?.getOnboardingStageTitle(model, stage) ??
			undefined
		);
	}

	public getStageDescription(model: DeviceModel, stage: OnboardingStage): string | undefined {
		return (
			this.plugins
				.get<DeviceCoverage3dOnboardingDeviceBehavior>(model)
				?.getOnboardingStageDescription(model, stage) ?? undefined
		);
	}

	public getStepTitle(model: DeviceModel, step: OnboardingStep): string | undefined {
		return (
			this.plugins.get<DeviceCoverage3dOnboardingDeviceBehavior>(model)?.getOnboardingStepTitle(model, step) ??
			undefined
		);
	}

	public getStepDescription(model: DeviceModel, step: OnboardingStep): string | undefined {
		return (
			this.plugins
				.get<DeviceCoverage3dOnboardingDeviceBehavior>(model)
				?.getOnboardingStepDescription(model, step) ?? undefined
		);
	}

	public getActionDescription(model: DeviceModel, action: OnboardingAction): string | undefined {
		return (
			this.plugins
				.get<DeviceCoverage3dOnboardingDeviceBehavior>(model)
				?.getOnboardingActionDescription(model, action) ?? undefined
		);
	}
}
